import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ToasterComponent, ToasterPlacement } from '@coreui/angular';
import { NotificationComponent } from './notification/notification.component';
import { Store } from '@ngrx/store';
import { selectNotifications } from '@src/app/stores/notifications.selectors';
import { debounce, filter, map } from 'rxjs';

@Component({
  selector: 'app-notification-wrapper',
  standalone: true,
  imports: [ToasterComponent],
  templateUrl: './notification-wrapper.component.html',
  styleUrl: './notification-wrapper.component.scss',
})
export class NotificationWrapperComponent implements OnDestroy {
  constructor(private _store: Store) {}

  private _notificationsStore = this._store.select(selectNotifications);

  private _crunch = true;

  private _notificationsSubscription = this._notificationsStore
    .pipe(
      map(({ notification }) => notification),
      filter((notification) => !!notification),
    )
    .subscribe((notification) => {
      this.addToast(
        notification.title,
        notification.notificationType,
        notification.message,
      );
    });

  @ViewChild(ToasterComponent) toaster!: ToasterComponent;

  addToast(title: string, type: string, message?: string) {
    const options = {
      title,
      message,
      type,
      delay: 5000,
      placement: ToasterPlacement.TopEnd,
      autohide: true,
    };
    const componentRef = this.toaster.addToast(NotificationComponent, {
      ...options,
    });
  }

  ngOnDestroy() {
    this._notificationsSubscription.unsubscribe();
  }
}
